<template>
  <div style="display: inline;">
    <ButtonComponent
      id="request_otp_login"
      :variant="$props.variant"
      :text="buttonText[$props.type][$props.lang]"
      :image="'https://cdn.systemico.net/abc/icons/email.svg'"
      @click="startValidation()"
      style="display: inline;min-width:280px;"
      class="text-center mt-2"
    >
    </ButtonComponent>
    <b-modal id="modal-email-signin" title="Email Validation ( OTP AUTH )" @hide="close">
      <b-container v-if="step == 1">
        <label>Type your email to open your account.</label>
        <b-form-input name="client"
                      v-model.trim="client"
                      @change="validateEmail"
                      @input="validateEmail();cleanSpace()"
                      :class="isEmailValid"
                      autocomplete="off"
                      :state="clientState"
                      placeholder="Type your email"
                      :type="$props.channelType"
                      required
        >
        </b-form-input>
        <small style="font-size: 11px;color:#aaaaaa;">We are going to send an email with a 6-digits code to access your account.</small>
      </b-container>
      <b-container v-if="step == 2">
        <InputOTP :digits="6"
                  text="We sent a <b>code to your email</b> to verificate your identity."
                  @complete="validate"
        >
        </InputOTP>
      </b-container>
      <b-container class="text-center" v-if="step == 3">
        <b-spinner class="mr-2" variant="primary" label="Loading..."></b-spinner><br>
        <label class="text-muted"> Code verification process ...</label>
      </b-container>
      <b-container class="text-center" v-if="step == 4">
        <b-alert show variant="success">
          <strong>Success!</strong> Your email has been verified.
        </b-alert>
      </b-container>
      <b-container class="text-center" v-if="step == 5">
        <b-alert show variant="danger">
          <strong>Fail!</strong> Your email couldn't be verified.
        </b-alert>
      </b-container>
      <!-- STEP 1 -->
      <template #modal-footer>
        <b-container class="text-right" v-if="step == 1">
          <ButtonComponent
              text="Send Code"
              @click="sendCode()"
              variant="success"
              icon="arrow-right"
              icon-position="end"
              v-show="clientState"
          >
          </ButtonComponent>
        </b-container>
        <b-container class="text-right" v-if="step == 2">
          <ButtonComponent
              text="Validate Email "
              @click="validate()"
              variant="primary"
              icon="shield-lock-fill"
              icon-position="start"
          >
          </ButtonComponent>
        </b-container>
        <b-container class="text-center" v-if="step >= 4">
          <ButtonComponent
              text="Close"
              @click="close"
              variant="secondary"
              icon="x"
              icon-position="start"
          >
          </ButtonComponent>
        </b-container>
      </template>
    </b-modal>
  </div>
</template>
<script>
import ButtonComponent from './ButtonComponent.vue';
import InputOTP from "../../components/input/InputOTP.vue";
import axios from "axios";
export default {
  name: 'ButtonEmailVerification',
  components:{
    InputOTP,
    ButtonComponent
  },
  data (){
    return {
      step: 1,
      client: '',
      token: '',
      clientState:null,
      buttonText: {
        LOGIN: {
          EN: 'Sign in <b>with your Email</b>',
          ES: 'Iniciar <b>con tu Email</b'
        },
        SIGNUP: {
          EN: 'Sign up <b>with your Email</b>',
          ES: 'Regístrate <b>con tu Email</b'
        }
      }
    }
  },
  props: {
    variant: String,
    channel: Number,
    lang: {
      type: String,
      default: 'EN'
    },
    type: {
      type: String,
      default: 'LOGIN'
    },
    channelType: {
      type: String,
      default: 'EMAIL'
    }
  },
  methods: {
    validateEmail() {
      // CLEAN SPACE
      this.cleanSpace()
      // VALIDATE EMAIL
      var emailCheck=/^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i;
      if (emailCheck.test(this.client)) {
        this.clientState = true
      } else {
        this.clientState = false
      }
    },
    cleanSpace () {
      this.client = this.client.replace(/^\s+|\s+$/gm,'')
    },
    // METHOD TO VALIDATE EMAIL
    async sendCode () {
      this.step = 2
      // DATA
      const datos =  {
        client: this.client,
        channel: this.channel
      }
      // CALL AXIOS AND SEND JSON
      await axios.post('/login/otp/send', datos).then(response => {
        let res = response.data
        this.token = res.DATA.TOKEN
      });
    },
    async validate(code){
      this.step = 3
      const datos = {
        client: this.client,
        channel: this.channel,
        token: this.token,
        code: code
      }
      // VALIDATE THE CODE TO COMPLETE THE LOGIN
      await axios.post('/login/otp/validate', datos).then(response => {
        let res = response.data
        if (res.CODE == 1){
          this.step = 4
          this.$bvModal.hide('modal-email-signin')
          window.location.href = "/redirect";
        }
        else{
          this.step = 5
          setTimeout(function() {
            this.step = 1
          }, 500)
        }
      });
      // SUCCESS THE LOGIN
      //this.$bvModal.hide('modal-email-signin')
    },
    startValidation(code){
      this.$bvModal.show('modal-email-signin')
      console.log(code)
    },
    close () {
      this.clientState = null
      this.step = 1
      this.client = ''
      this.$bvModal.hide('modal-email-signin')
    },
    isEmailValid: function() {
      return (this.email === '')? '' : (this.reg.test(this.email)) ? 'has-success' : 'has-error'
    }
  }
}
</script>
<style lang="scss" scoped>
  @import "../../variables.scss";
</style>
